import { struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Request = struct({
	name: iotsUtils.NotEmptyString,
});
